import { ScopePermissions } from '../types/auth.types';

export const defaultPermissions: ScopePermissions = {
  canReadAlerts: false,
  canCreateAlerts: false,
  canSendAlerts: false,
  canEliminateAlerts: false,
};

export const calculatePermissions = (scopes: string[]): ScopePermissions => ({
  canReadAlerts: scopes.includes('read:alert'),
  canCreateAlerts: scopes.includes('create:alert'),
  canSendAlerts: scopes.includes('send:alert'),
  canEliminateAlerts: scopes.includes('eliminate:alert'),
});
